import * as C from "react";
import { forwardRef as o } from "react";
const n = o(function(e, l) {
  return /* @__PURE__ */ C.createElement(
    "svg",
    {
      fill: "none",
      ref: l,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e
    },
    /* @__PURE__ */ C.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M12.4643 2.03996C12.4872 2.04917 12.5093 2.06051 12.5372 2.07446C12.8352 2.20489 13.0215 2.46566 13.0215 2.80098C13.0215 3.18062 12.7468 3.44579 12.4576 3.54267C12.4968 3.68595 12.5186 3.84852 12.5186 4.03041C16.7843 4.53338 20.1 8.12848 20.1 12.5246C20.1 17.2373 16.2814 21.0745 11.55 21.0745C6.81865 21.0745 3 17.2373 3 12.5246C3 8.16571 6.31568 4.53338 10.5441 4.03041C10.5441 3.84386 10.5679 3.67763 10.6102 3.53169C10.327 3.42404 10.0784 3.15575 10.0784 2.80098C10.0784 2.29801 10.5068 2 10.8793 2H11.5686C12.2497 2 12.3651 2 12.4643 2.03996ZM4.67649 12.5246C4.67649 16.4549 8.08528 19.4353 11.55 19.4353C15.1078 19.4353 18.4422 16.0451 18.4422 12.5246C18.4422 8.89215 15.1824 5.63236 11.55 5.63236C7.95486 5.63236 4.67649 8.59415 4.67649 12.5246ZM11.7922 12.4873L9.05392 7.77452C8.9608 7.60686 8.79314 7.51374 8.62549 7.51374C8.51372 7.51374 8.4206 7.55097 8.34606 7.58828C8.1784 7.6814 8.08528 7.84905 8.08528 8.01671C8.08528 8.10983 8.10394 8.2216 8.15982 8.31472L10.8608 13.0088C10.9725 13.1765 11.1588 13.2697 11.3265 13.2697C11.4196 13.2697 11.5127 13.251 11.5873 13.1951C11.7735 13.102 11.8666 12.9343 11.8666 12.7295C11.8666 12.6549 11.848 12.5618 11.7922 12.4873Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  n as InPlay
};
